/**
 * Клавиатурная дорожка к заметкам на полях: выделение мышью не должно быть
 * единственным способом спросить. Берём начало текущей главы как якорь.
 */
export function chapterQuote(content: string, activeHeading: string) {
  const blocks = content.split(/\n\s*\n/).map((block) => block.trim()).filter(Boolean);
  const headingAt = activeHeading
    ? blocks.findIndex((block) => block.startsWith("## ") && block.slice(3).trim() === activeHeading)
    : -1;
  const from = headingAt >= 0 ? headingAt + 1 : 0;
  const paragraph = blocks.slice(from).find((block) => !/^(#{1,6}\s|\[\[ILLUSTRATION_|- |> )/.test(block));
  const text = (paragraph || blocks[0] || "").replace(/\[\[ILLUSTRATION_\d+\]\]/g, " ").replace(/\s+/g, " ").trim();
  return text.slice(0, 300);
}
